/**
 * Utilidades de geolocalizacion y distancia
 * Sin dependencias externas - usa Geolocation API del navegador y formula Haversine
 */

export const getUserLocation = (timeoutMs = 8000) => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("Geolocation no soportada"))
            return
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                })
            },
            (error) => {
                reject(error)
            },
            {
                enableHighAccuracy: false,
                timeout: timeoutMs,
                maximumAge: 300000
            }
        )
    })
}

export const haversineDistance = (coord1, coord2) => {
    const R = 6371
    const toRad = (deg) => deg * (Math.PI / 180)

    const dLat = toRad(coord2.lat - coord1.lat)
    const dLng = toRad(coord2.lng - coord1.lng)

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2)

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

    return R * c
}

export const sortSedesByDistance = (sedes, userLocation) => {
    return sedes
        .map(sede => {
            if (sede.coordenadas && sede.coordenadas.lat && sede.coordenadas.lng) {
                return {
                    ...sede,
                    distance: haversineDistance(userLocation, sede.coordenadas)
                }
            }
            return { ...sede, distance: null }
        })
        .sort((a, b) => {
            if (a.distance === null && b.distance === null) return 0
            if (a.distance === null) return 1
            if (b.distance === null) return -1
            return a.distance - b.distance
        })
}

export const formatDistance = (km) => {
    if (km === null || km === undefined) return ""
    if (km < 1) {
        return Math.round(km * 1000) + " m"
    }
    return km.toFixed(1) + " km"
}
